/**
 * GoogleTagManagerEvents
 *
 * modul slouží k volání funkce pro odesílání eventů do GTM při zobrazení jedné položky carouselu
 *
 * hledá se atribut data-gtag na konkrétním .carousel-item
 *
 * data-tag="{'event', 'event_name', {'event_category': 'Kategorie', 'event_label': 'Popisek', ...}}"
 *
 * pro použití a spuštění stačí vložit do index.js řádku:
 * import "./js/Spinao/GoogleTagManagerCarousel";
 */





function applyGTag(carouselItem)
{
    if(carouselItem.dataset.gtag) {
        let gtagSett = JSON.parse(carouselItem.dataset.gtag);
        gtag.apply(this, gtagSett);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.carousel-item.active').forEach(function(item) {
        applyGTag(item);
    });

    document.addEventListener('slid.bs.carousel', function(event) {
        if (typeof gtag === "function") {
            let active = event.target.querySelector('.carousel-item.active');
            applyGTag(active);
        }
    });
});
